import { combineReducers, createStore, applyMiddleware, compose, Store } from 'redux';
import reduxSaga from 'redux-saga';
import { save, load } from 'redux-localstorage-simple';

import { rootSaga } from './rootSaga';
import { appSlice } from './app/slice';
import { nftSlice } from './nft/slice';
import { transactionsSlice } from './transactions/slice';

// state
export const rootReducer = combineReducers({
  app: appSlice.reducer,
  nft: nftSlice.reducer,
  transactions: transactionsSlice.reducer,
});
export type RootState = ReturnType<typeof rootReducer>;

// caching state
export const transactionSaveOptions = {
  states: ['transactions'],
  namespace: '',
};

// middlewares
const sagaMiddleware = reduxSaga();
const middleware = [sagaMiddleware, save(transactionSaveOptions)];

// store
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const storeCreator = (initialState?: Partial<RootState>): Store<RootState> =>
  createStore(
    rootReducer,
    { ...(initialState || {}) },
    process.env.NODE_ENV === 'production'
      ? applyMiddleware(...middleware)
      : composeEnhancers(applyMiddleware(...middleware)),
  );
const loadedState = load(transactionSaveOptions);
export const store = storeCreator(loadedState);

sagaMiddleware.run(rootSaga);
